<ng-container *ngIf="loaded">
  <ng-container [ngSwitch]="action.config.provider">
    <ng-container *ngSwitchCase="'textract'">
      <app-textract-kyc-provider
        (completed)="onComplete()"
      ></app-textract-kyc-provider>
    </ng-container>
    <ng-container *ngSwitchCase="'thirdfort'">
      <app-thirdfort-kyc-provider
        (completed)="onComplete()"
      ></app-thirdfort-kyc-provider>
    </ng-container>
    <ng-container *ngSwitchCase="'veriff'">
      <app-veriff-kyc-provider
        (completed)="onComplete()"
      ></app-veriff-kyc-provider>
    </ng-container>
    <ng-container *ngSwitchCase="'verifflite'">
      <app-veriff-lite-kyc-provider
        (completed)="onComplete()"
      ></app-veriff-lite-kyc-provider>
    </ng-container>
    <ng-container *ngSwitchDefault>
      <app-document-kyc-upload-modal
        (completed)="onComplete()"
      ></app-document-kyc-upload-modal>
    </ng-container>
  </ng-container>
</ng-container>
